import { Media } from "@knowt/syncing/graphql/schema";
import { EXCEL_FORMATS, PDF_FORMATS, PPT_FORMATS, VIDEO_FORMATS, AUDIO_FORMATS } from "./constants";

export const isPDF = (item: Media | null | undefined) => PDF_FORMATS.includes(item?.fileType);
export const isExcel = (item: Media | null | undefined) => EXCEL_FORMATS.includes(item?.fileType);
export const isPPT = (item: Media | null | undefined) => PPT_FORMATS.includes(item?.fileType);
export const isVideo = (item: Media | null | undefined) => VIDEO_FORMATS.includes(item?.fileType);
export const isAudio = (item: Media | null | undefined) => AUDIO_FORMATS.includes(item?.fileType);
